/**
 * Call Permissions Constants
 *
 * Defines permission presets for different call states.
 */

import type { CallPermissions } from '../types';

/**
 * Default permissions for inactive/terminal states
 */
export const NO_PERMISSIONS: CallPermissions = {
  canMute: false,
  canHold: false,
  canTransfer: false,
  canMerge: false,
  canUseKeypad: false,
  canUseVideo: false,
  canHangUp: false,
};

/**
 * Full permissions for established calls
 */
export const FULL_PERMISSIONS: CallPermissions = {
  canMute: true,
  canHold: true,
  canTransfer: true,
  canMerge: true,
  canUseKeypad: true,
  canUseVideo: true,
  canHangUp: true,
};

/**
 * Ongoing call permissions - mute, hold, transfer, keypad, video, and hang up.
 * canMerge is false by default — it's computed dynamically in selectPermissions selector.
 * canTransfer is true here as a base — the selector further restricts it
 * to only the `active` state and non-conference calls.
 */
export const ONGOING_CALL_PERMISSIONS: CallPermissions = {
  canMute: true,
  canHold: true,
  canTransfer: true,
  canMerge: false,
  canUseKeypad: true,
  canUseVideo: true,
  canHangUp: true,
};

/**
 * Limited permissions for establishing/reconnecting states
 */
export const ESTABLISHING_PERMISSIONS: CallPermissions = {
  canMute: true,
  canHold: false,
  canTransfer: false,
  canMerge: false,
  canUseKeypad: false,
  canUseVideo: false,
  canHangUp: true,
};
